import { useContext } from 'react';

import AnimateView from '@/react_app/components/BillingUsage/AnimateView';
import FeaturesCard from '@/react_app/components/BillingUsage/Overview/FeaturesCard';
import OverviewSectionWithRefresh from '@/react_app/components/BillingUsage/Overview/OverviewSectionWithRefresh';
import { OverviewContextType } from '@/react_app/components/BillingUsage/Overview/types';
import { OverviewContext } from '@/react_app/components/BillingUsage/contexts';

const BillingUsageOverview = () => {
	const { overviewSectionWithRefresh, teamFeaturesSection, customerFeaturesSection, automationFeaturesSection, creditsFeaturesSection } =
		useContext(OverviewContext) as OverviewContextType;
	return (
		<AnimateView>
			<div className="space-y-10">
				<OverviewSectionWithRefresh {...overviewSectionWithRefresh} />
				<FeaturesCard {...teamFeaturesSection} />
				<FeaturesCard {...customerFeaturesSection} />
				<FeaturesCard {...automationFeaturesSection} />
				<FeaturesCard {...creditsFeaturesSection} />
			</div>
		</AnimateView>
	);
};

export default BillingUsageOverview;
